import { NavLink } from "react-router-dom";
import { FaHome, FaBookOpen, FaClipboardList, FaInfoCircle } from "react-icons/fa";
import "./layout.css";

export default function Footer() {
  return (
    <footer className="bottom-nav">
      <NavLink to="/" className="nav-item">
        <FaHome className="icon" />
        <span>Home</span>
      </NavLink>

      <NavLink to="/subjects" className="nav-item">
        <FaBookOpen className="icon" />
        <span>Solutions</span>
      </NavLink>

      <NavLink to="/subject" className="nav-item">
        <FaClipboardList className="icon" />
        <span>Mock Test</span>
      </NavLink>

      <NavLink to="/about" className="nav-item">
        <FaInfoCircle className="icon" />
        <span>About</span>
      </NavLink>
    </footer>
  );
}